/*
 * The view for the description on the content page
 */

define(["marionette", "./template/contentNotesTemplate.html"], function (
  Marionette,
  ContentNotesTemplate,
) {
  var ContentNotesView = {};

  ContentNotesView.contentNotesView = Marionette.ItemView.extend({
    template: ContentNotesTemplate,
    modelEvents: {
      change: "render",
    },
    textboxes: {
      "#descriptionTextField": {
        enableSelector: ["#descriptionTextField", ".item-label"],
        modelAttribute: "description",
        placeholder: "content.description",
        textArea: true,
      },
    },
  });

  return ContentNotesView;
});
